import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Popper } from '@lyearn/ui';

import BlockMenuList from '../../components/Menu/BlockMenuItems';
import { menuItems } from './consts';
import { LinkMenuProps } from './types';
import { useAnchorEl, usePopperOptions } from './useActionLinkMenu';

export const LinkMenuComponent: React.FC<LinkMenuProps> = (props) => {
  let { open, view } = props;
  const { t } = useTranslation();

  const anchorEl = useAnchorEl(view, open);
  const popperOptions = usePopperOptions(view, open);

  return (
    <Popper
      anchorEl={anchorEl}
      className="z-10 rounded-8 border border-divider bg-bg-primary shadow-02"
      id="link-menu-button-popper"
      open={open}
      placement={'bottom-start'}
      popperOptions={popperOptions}>
      <BlockMenuList anchorEl={anchorEl} menuItems={menuItems(t)} open={open} view={view} />
    </Popper>
  );
};
